@for (rfqSessionSupplier of rfqSessionSuppliers; track $index) {
	<div class="row">
		<div class="col">
			<h5 class="add-underline blue-text">{{ rfqSessionSupplier.supplier.name }}</h5>
		</div>
	</div>
	@if (rfqSessionSupplier.note) {
		<div class="row">
			<div class="col">
				<p>
					<span class="semibold-text">{{ rfqSessionSupplier.noteAddDate | date: 'MM/dd/yyyy' }}</span
					><br />
					{{ rfqSessionSupplier.note }}
				</p>
			</div>
			<div class="col-auto">
				<p>
					<button type="button" class="btn btn-link btn-sm p-0 no-right-margin" (click)="editNote.emit({ rfqSessionSupplier, noteKey: 'note' })">
						<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon> Edit
					</button>
				</p>
			</div>
		</div>
	}
	@if (rfqSessionSupplier.loaRequestNote) {
		<div class="row">
			<div class="col">
				<p>
					<span class="semibold-text">{{ rfqSessionSupplier.loaRequestDate | date: 'MM/dd/yyyy' }}</span
					><br />
					{{ rfqSessionSupplier.loaRequestNote }}
				</p>
			</div>
			<div class="col-auto">
				<p>
					<button
						type="button"
						class="btn btn-link btn-sm p-0 no-right-margin"
						(click)="editNote.emit({ rfqSessionSupplier, noteKey: 'loaRequestNote' })">
						<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon> Edit
					</button>
				</p>
			</div>
		</div>
	}
	@if (rfqSessionSupplier.loeRequestNote) {
		<div class="row">
			<div class="col">
				<p>
					<span class="semibold-text">{{ rfqSessionSupplier.loeRequestDate | date: 'MM/dd/yyyy' }}</span
					><br />
					{{ rfqSessionSupplier.loeRequestNote }}
				</p>
			</div>
			<div class="col-auto">
				<p>
					<button
						type="button"
						class="btn btn-link btn-sm p-0 no-right-margin"
						(click)="editNote.emit({ rfqSessionSupplier, noteKey: 'loeRequestNote' })">
						<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon> Edit
					</button>
				</p>
			</div>
		</div>
	}
	@if (rfqSessionSupplier.sampleBillRequestNote) {
		<div class="row">
			<div class="col">
				<p>
					<span class="semibold-text">{{ rfqSessionSupplier.sampleBillRequestDate | date: 'MM/dd/yyyy' }}</span
					><br />
					{{ rfqSessionSupplier.sampleBillRequestNote }}
				</p>
			</div>
			<div class="col-auto">
				<p>
					<button
						type="button"
						class="btn btn-link btn-sm p-0 no-right-margin"
						(click)="editNote.emit({ rfqSessionSupplier, noteKey: 'sampleBillRequestNote' })">
						<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon> Edit
					</button>
				</p>
			</div>
		</div>
	}
	@if (rfqSessionSupplier.optOutReasonType) {
		<div class="row">
			<div class="col">
				<p>
					<span class="semibold-text">{{ rfqSessionSupplier.optOutReasonNoteAddDate | date: 'MM/dd/yyyy' }}</span
					><br />
					{{ rfqSessionSupplier.supplier.name }} has opted out of the pricing session: {{ rfqSessionSupplier.optOutReasonType.name }}:
					{{ rfqSessionSupplier.optOutReasonNote }} ({{ rfqSessionSupplier.optOutReasonNoteAddDate | date: 'MM/dd/yyyy' }})
					@if (!rfqSessionSupplier.isOptOut) {
						<br /><br />
						{{ rfqSessionSupplier.supplier.name }} has opted back into the pricing session.
					}
				</p>
			</div>
			<div class="col-auto">
				<p>
					<button
						type="button"
						class="btn btn-link btn-sm p-0 no-right-margin"
						(click)="editNote.emit({ rfqSessionSupplier, noteKey: 'optOutReasonNote' })">
						<fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon> Edit
					</button>
				</p>
			</div>
		</div>
	}
}
